import { render } from "./Main.vue?vue&type=template&id=4587e27b"
const script = {}
script.render = render

export default script